import styled from 'styled-components'

type ContainerProps = {
  open: boolean
  optionsLength: number
}

const renderBoxHeight = (optionsLength: number) => {
  if (optionsLength === 1) {
    return 96
  } else {
    return 47.5
  }
}

export const Container = styled.div<ContainerProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 0.02px solid ${({ theme }) => theme.colors.primary};
  border-bottom: none;
  transition: height 0.25s ease-out;
  height: ${({ open, optionsLength }) => (open ? `${optionsLength * renderBoxHeight(optionsLength)}px` : '46px')};
  overflow: hidden;
`

export const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 10px;
  padding-right: 20px;
`

export const HeaderTitle = styled.div`
  margin: 16px 0;
`

export const Title = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: 0.09px;
  color: ${({ theme }) => theme.colors.dark};
`

type OptionProps = {
  selected: boolean
  last: boolean
}

export const Option = styled.div<OptionProps>`
  cursor: pointer;
  width: 100%;
  display: flex;
  align-items: center;
  height: 34px;
  border-top: none;
  border-bottom: ${(props) => (props.last ? 'inherit' : 'none')};
  background-color: ${({ theme, selected }) => (selected ? theme.colors.lightBackground : theme.colors.white)};
`

export const OptionLabel = styled.div`
  height: 100%;
  width: 10px;
  background-color: ${(props) => props.color};
`

export const OptionText = styled.p`
  margin: 0;
  margin-left: 16px;
  font-size: 16px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.default};
  text-transform: capitalize;
`
